<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header
      :showGoBack="true"
      title="Top-Up payment"
    />

    <main
      :class="'scrollable container'"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <!-- Cards -->
      <section :style="{marginBottom: '30px'}">
        <span
          :class="'t14'"
          :style="{marginBottom: '10px', display: 'block'}"
          >Cards</span
        >
        <ul>
          <li
            :key="card.id"
            v-for="card in cards"
            :style="{
              gap: '12px',
              padding: '12px',
              borderRadius: '12px',
              backgroundColor: '#FFF7F2',
            }"
            :class="'clickable row-center'"
          >
            <img
              :src="card.image"
              alt="card"
              :style="{width: '62px', height: 'auto', borderRadius: '6px'}"
            />
            <div
              :style="{
                display: 'flex',
                flexDirection: 'column',
              }"
            >
              <span :class="'t12'">
                {{ card.number }}
              </span>
              <h6>{{ card.balance }} USD</h6>
            </div>
          </li>
        </ul>
      </section>

      <!-- Entrepreneur accounts -->
      <section :style="{marginBottom: '30px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Entrepreneur accounts</span
        >
        <div
          :style="{
            gap: '10px',
            padding: '12px',
            borderRadius: '10px',
            backgroundColor: '#FFF7F2',
          }"
          :class="'row-center'"
        >
          <EnterpreneurAccSvg />
          <div class="column-start">
            <span class="t12">US**********************4571</span>
            <h6>39 863.62 USD</h6>
          </div>
        </div>
      </section>

      <!-- Other methods -->
      <section>
        <ul>
          <li
            :key="method.id"
            v-for="(method, index) in methods"
            :style="{
              gap: '14px',
              marginBottom: index === methods.length - 1 ? '0' : '20px',
            }"
            :class="'clickable row-center'"
          >
            <component
              alt="method"
              :is="method.icon"
            />
            <span :style="{marginRight: 'auto'}">{{ method.title }}</span>
            <InfoSvg />
          </li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script setup>
// hooks
import {useOpacity} from '@/hooks';

// components
import {Header} from '@/components';

// svg
import {WUSvg} from '@/assets/svg';
import {InfoSvg} from '@/assets/svg';
import {SepaSvg} from '@/assets/svg';
import {PayPalSvg} from '@/assets/svg';
import {PayoneerSvg} from '@/assets/svg';
import {TopUpCreditCardSvg} from '@/assets/svg';
import {EnterpreneurAccSvg} from '@/assets/svg';

const opacity = useOpacity();

const cards = [
  {
    id: 1,
    number: '**** **** **** 7895',
    balance: '4 863.27',
    image: require('@/assets/cards/01.jpg'),
  },
];

const methods = [
  {
    id: 1,
    icon: TopUpCreditCardSvg,
    title: 'Card from another bank',
  },
  {
    id: 2,
    icon: SepaSvg,
    title: 'SEPA',
  },
  {
    id: 3,
    icon: WUSvg,
    title: 'Western Union',
  },
  {
    id: 4,
    icon: PayPalSvg,
    title: 'Paypal',
  },
  {
    id: 5,
    icon: PayoneerSvg,
    title: 'Payoneer',
  },
];
</script>
